module.exports = __webpack_public_path__ + "static/media/Lab_Coat.aa45c673.svg";